import { useState } from "react";

import { cn } from "~/lib/utils";

import { MorrowAgentOrb } from "../brand/MorrowAgentOrb";
import { MORROW_BROWSER_LOGO_URL } from "./morrowBuiltInToolDisplay";
import { isMorrowNativeToolSlug, type WorkEntryIntegration } from "./workEntryStep";

export function IntegrationStepIcon({
  integration,
  className,
}: {
  integration: WorkEntryIntegration;
  className?: string | undefined;
}) {
  const [failed, setFailed] = useState(false);

  if (isMorrowNativeToolSlug(integration.slug)) {
    return <MorrowAgentOrb className={cn("shrink-0", className ?? "size-3.5")} />;
  }

  const src =
    integration.slug === "browser"
      ? MORROW_BROWSER_LOGO_URL
      : `https://logos.composio.dev/api/${integration.slug}`;

  if (failed) {
    return (
      <span
        className={cn(
          "flex size-3.5 shrink-0 items-center justify-center rounded-[3px] bg-muted text-[8px] font-semibold uppercase leading-none text-muted-foreground",
          className,
        )}
        aria-hidden
      >
        {integration.name.slice(0, 1)}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "flex size-3.5 shrink-0 items-center justify-center overflow-hidden rounded-[3px] bg-white",
        className,
      )}
    >
      <img
        src={src}
        alt=""
        loading="lazy"
        onError={() => setFailed(true)}
        className="size-3 object-contain"
      />
    </span>
  );
}
